import libphonenumber from "google-libphonenumber";
const invalidErrorObj = { "invalidPhoneNumber": true };
export function phoneNumberValidator(control) {
    if (control.value != null && control.value != "") {
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        const validString = checkAgainstStrings(control);
        if (control.value.length > 5 && validString) {
            let stringValue = control.value.trim();
            try {
                if (stringValue[0] == "0") {
                    stringValue = stringValue.replace("0", "+27");
                }
                const number = phoneUtil.parseAndKeepRawInput(stringValue);
                const validNumber = phoneUtil.isValidNumber(number);
                if (validNumber) {
                    return null;
                }
                else {
                    setError(control);
                    return invalidErrorObj;
                }
            }
            catch (err) {
                setError(control);
                return invalidErrorObj;
            }
        }
        else {
            setError(control);
            return invalidErrorObj;
        }
    }
}
function checkAgainstStrings(control) {
    const acceptableCharacters = ["/", "-"];
    let validCharacter = true;
    if (control.value.length > 5) {
        for (let i = 1; i < control.value.length; i++) {
            if (isNaN(control.value[i]) && acceptableCharacters.indexOf(control.value[i]) < 0) {
                validCharacter = false;
                break;
            }
        }
    }
    return validCharacter;
}
function setError(control) {
    control.setErrors(invalidErrorObj);
}
